import { css } from "@emotion/react";

import { colors, InfoIcon } from "@dotnet/telematics-design-system";

import {
    TOOLTIP_PLACEMENT,
    TooltipLarge
} from "components/DesignComponents/Tooltips";
import { svgFontSize } from "shared";

import { InfoTooltipProps } from "./types";

const InfoTooltip = ({ title, isLarge, ...props }: InfoTooltipProps) => {
    const { blue700 } = colors;

    return (
        <TooltipLarge title={title} placement={TOOLTIP_PLACEMENT.Top}>
            <span {...props} css={css({ display: "flex" })}>
                <InfoIcon
                    css={css({
                        color: blue700,
                        ...svgFontSize(isLarge ? 24 : 16)
                    })}
                />
            </span>
        </TooltipLarge>
    );
};

export { InfoTooltip };
